import React from 'react'
import {connect} from 'react-redux'
import {NavLink, Redirect, withRouter} from 'react-router-dom';
import {Auth} from '../services/Auth';
import {logout} from '../actions/LoginActions';
import {injectIntl} from 'react-intl'
import {getPermissions, getProjectId} from "../actions/AffiliateActions";
import configs from "../constants/Configs";

/**
 * Enum for Cheching user type.
 * @readonly
 * @enum {number}
 */

export const userTypeEnum = {
    /** Users in Main Affiliate site */
    MainPartner: 1,
    /** Users in SubAffiliate site */
    SubPartner: 2
}

class MainMenu extends React.Component {

    componentDidMount() {
        const {affiliateId} = this.props.affiliates;
        const {userType, currentUserType} = this.props.user;

        affiliateId && Number(userType) === userTypeEnum.SubPartner && this.props.dispatch(getPermissions(affiliateId));
        affiliateId && Number(currentUserType) === userTypeEnum.SubPartner && this.props.dispatch(getProjectId(affiliateId));
    }

    componentDidUpdate(prevProps, prevState) {
        const {affiliateId} = this.props.affiliates;
        const {userType} = this.props.user;
        const {currentUserType} = this.props.user;

        if (prevProps.affiliates.affiliateId !== affiliateId) {
            currentUserType === userTypeEnum.SubPartner && this.props.dispatch(getProjectId(affiliateId));
            userType === userTypeEnum.SubPartner && this.props.dispatch(getPermissions(affiliateId));
        }
    }

    render() {
        const {currentUserType} = this.props.user;
        const {permissions} = this.props.affiliates;
        const {projectId} = this.props.affiliates;
        const designURL = configs.BUILDER_URL + '/sso?token=' + encodeURI(Auth.token) + "&projectId=" + projectId;

        if (!this.props.user.isLoggedIn && !Auth.isAuthenticated()) {
            return <Redirect to='/login'/>;
        }

        return (
            <div className="sidenav">
                <ul>
                    {parseInt(currentUserType, 10) === userTypeEnum.MainPartner ? (
                        <React.Fragment>
                            <li><NavLink activeClassName="ta-active_side_item" to={'/affiliates'}><i
                                className="fi case-icon"></i><span>{this.props.intl.messages.affiliates}</span></NavLink>
                            </li>
                            <li><NavLink activeClassName="ta-active_side_item" to={'/reports'}><i
                                className="fi docs-icon"></i><span>{this.props.intl.messages.reports}</span></NavLink>
                            </li>
                            <li><NavLink activeClassName="ta-active_side_item" to={'/withdraw'}><i
                                className="fi coins-icon"></i><span>{this.props.intl.messages.withdraw}</span></NavLink>
                            </li>
                            <li><NavLink activeClassName="ta-active_side_item" to={'/domains'}><i
                                className="fi globe-icon"></i><span>{this.props.intl.messages.domains}</span></NavLink>
                            </li>
                            <li><NavLink activeClassName="ta-active_side_item" to={'/users'}><i
                                className="fi user-icon"></i><span>{this.props.intl.messages.users}</span></NavLink>
                            </li>
                            <li><NavLink activeClassName="ta-active_side_item" to={'/signups'}><i
                                className="fi signup-icon"></i><span>{this.props.intl.messages.sign_ups}</span></NavLink>
                            </li>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            {permissions && permissions.includes('Reports') && (
                                <li><NavLink activeClassName="ta-active_side_item" to={'/reports'}><i
                                    className="fi docs-icon"></i><span>{this.props.intl.messages.reports}</span></NavLink>
                                </li>
                            )}
                            <li><NavLink activeClassName="ta-active_side_item" to={'/withdraw'}><i
                                className="fi coins-icon"></i><span>{this.props.intl.messages.withdraw}</span></NavLink>
                            </li>
                            <li><NavLink activeClassName="ta-active_side_item" to={'/players'}><i
                                className="fi users-icon"></i><span>{this.props.intl.messages.players}</span></NavLink>
                            </li>
                            <li><NavLink activeClassName="ta-active_side_item" to={'/domains'}><i
                                className="fi globe-icon"></i><span>{this.props.intl.messages.domains}</span></NavLink>
                            </li>
                            {permissions && permissions.includes('ChangeDesign') && (
                                <li>
                                    <a target='_blank' href={designURL}>
                                        <i className="fi paintbrush-icon"></i>
                                        <span>{this.props.intl.messages.designs}</span>
                                    </a>
                                </li>)}
                            <li><NavLink activeClassName="ta-active_side_item" to={'/account'}><i
                                className="fi user-icon"></i><span>{this.props.intl.messages.commissions}</span></NavLink>
                            </li>
                        </React.Fragment>
                    )}
                </ul>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch, props) => {
    return ({
        dispatch,
        logout: () => {
            dispatch(logout());
        }
    });
}

const mapStateToProps = state => {
    return {
        user: state.user,
        affiliates: state.affiliates,
    }
}

export default injectIntl(withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(MainMenu)));




// WEBPACK FOOTER //
// ./src/layouts/MainMenu.js